export default __webpack_public_path__ + "assets/hotgiggity-logo.14b56a12.png";